import actions from './actions.js';
import mutations from './mutations.js';
import getters from './getters.js';

// Public dance directory: genres, schools on the map, events, details.
export default {
  namespaced: true,
  state() {
    return {
      genres: [],
      schools: [],
      schoolsLoading: false,
      schoolsError: null,
      events: [],
      eventsTotal: 0,
      eventsLoading: false,
      // Filtered events of the /events page (list and map); `events` above is
      // the plain upcoming list used on the home page.
      eventSearch: [],
      eventSearchLoading: false,
      eventSearchError: null,
      todayClasses: [],
      currentSchool: null,
      currentEvent: null,
      currentOrganizer: null,
      detailLoading: false,
      detailError: null,
    };
  },
  actions,
  mutations,
  getters,
};
